/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useState } from 'react';
import S3UploadHook from '../../CommonMethods/S3UploadHook';
import { ColorRing } from 'react-loader-spinner';

export default function LogoUpload({
    state,
    id,
    setState,
    setimageLoading,
    imageLoading,
    s3Prefix,
    newState,
    setAllowUpdate = () => {}, 
    customeLogo, 
    setCustomeLogo = () => {}
}) {
    const imageTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    const [error, setError] = useState('');
    const CDNurl = import.meta.env.VITE_CDN_URL;

    // Handle File Upload
    async function handleUploadChange(e) {
        // setAllowUpdate(true)
        setimageLoading(true);
        setError('');
        let file = e.target.files[0];

        if (!file) {
            setError('Logo upload is required.');
            setimageLoading(false);
            return;
        }

        // Validate file type
        if (!imageTypes.includes(file.type)) {
            setError('Please upload a PNG, JPEG, or JPG image.');
            setimageLoading(false);
            e.target.value = null;
            return;
        }

        // Validate file size (max 5MB)
        const maxSize = 5 * 1024 * 1024; 
        if (file.size > maxSize) {
            setError('File size should not exceed 5MB.');
            setimageLoading(false);
            e.target.value = null;
            return;
        }

        const uploadedKey = await S3UploadHook(file, `${s3Prefix}`);
        // A failed upload resolves to undefined, which used to be saved as the literal
        // path "public/undefined" and left the store with a broken logo.
        if (!uploadedKey) {
            setError('Logo upload failed. Please try again.');
            setimageLoading(false);
            e.target.value = null;
            return;
        }
        const url = 'public/' + uploadedKey;

        setState((prev) => ({
            ...prev,
            store_logo: url,
            custom_store_settings: {
                ...prev.custom_store_settings,
                store_logo: url,
            },
        }));
        setCustomeLogo((prev) => ({
            ...prev,
            store_logo: url,
        }))
        setError(""); // Clear error if upload is successful
        setimageLoading(false);
        e.target.value = null;
    }

    // Remove File
    const handleRemove = () => {
        if(customeLogo){
            setCustomeLogo((prev) => ({
                ...prev,
                store_logo: '',
            }))
        } else {
            setState((prev) => ({
                ...prev,
                store_logo: '',
                custom_store_settings: {
                    ...prev.custom_store_settings,
                    store_logo: '',
                }, 
            }));

        }
    };

    return (
        <div className="relative mb-3 cursor-pointer w-fit">
            {/* Upload Button */}
            {customeLogo ? (
                <div className="relative w-fit group">
                    <img
                        src={`${CDNurl}${customeLogo}`}
                        alt="Store Logo"
                        className={`w-[125px] h-[125px] object-cover  rounded-[70px] 
                            ${newState?.custom_store_theme ? 'rounded-full' : ''}`} // Circular format for custom store theme
                    />
                    <div
                        className="absolute top-0 left-0 flex items-center justify-center w-full h-full opacity-0 
                        bg-black bg-opacity-50 group-hover:opacity-100 transition-opacity"
                    >
                        <img
                            src="/assets/images/x-circle.svg"
                            alt="Remove Logo"
                            className="cursor-pointer"
                            onClick={handleRemove}
                        />
                    </div>
                </div>
            ) :state?.custom_store_settings?.store_logo ? (
                <div className="relative w-fit group">
                    <img
                        src={`${CDNurl}${state?.custom_store_settings?.store_logo}`}
                        alt="Store Logo"
                        className={`w-[125px] h-[125px] object-cover  rounded-[70px] 
                            ${newState?.custom_store_theme ? 'rounded-full' : ''}`} // Circular format for custom store theme
                    />
                    <div
                        className="absolute top-0 left-0 flex items-center justify-center w-full h-full opacity-0 
                        bg-black bg-opacity-50 group-hover:opacity-100 transition-opacity"
                    >
                        <img
                            src="/assets/images/x-circle.svg"
                            alt="Remove Logo"
                            className="cursor-pointer"
                            onClick={handleRemove}
                        />
                    </div>
                </div>
            ) : state?.store_logo ? (
                <div className="relative w-fit group">
                    <img
                        src={`${CDNurl}${state.store_logo}`}
                        alt="Store Logo"
                        className={`w-[125px] h-[125px] object-cover  rounded-[70px] 
                            ${newState?.custom_store_theme ? 'rounded-full' : ''}`} // Circular format for custom store theme
                    />
                    <div
                        className="absolute top-0 left-0 flex items-center justify-center w-full h-full opacity-0 
                        bg-black bg-opacity-50 group-hover:opacity-100 transition-opacity"
                    >
                        <img
                            src="/assets/images/x-circle.svg"
                            alt="Remove Logo"
                            className="cursor-pointer"
                            onClick={handleRemove}
                        />
                    </div>
                </div>
            ) : (
                <>
                    <input
                        type="file"
                        id="fileUpload"
                        data-test-id="store-logo-upload"
                        className="hidden"
                        accept="image/jpeg, image/png"
                        onChange={handleUploadChange}
                    />
                    <label
                        htmlFor="fileUpload"
                        className="py-2 px-4 h-[34px] w-[130px] rounded-[12px] flex justify-center items-center 
                        border border-[#9E2064] cursor-pointer"
                    >
                        {imageLoading ? (
                            <ColorRing
                                visible={true}
                                height="25"
                                width="25"
                                ariaLabel="loading"
                                colors={['#9E2064', '#9E2064', '#9E2064']}
                            />
                        ) : (
                            <div className="flex">
                                <p className="text-[#9E2064] font-normal text-xs mr-2">Upload image</p>
                                <img src="/assets/images/upload.svg" alt="upload icon" />
                            </div>
                        )}
                    </label>
                    <p className="text-xs mt-2 font-normal text-[#1F1F1F]">File size: Up to 5MB</p>
                    {error && <p className="text-xs font-normal text-[#F04438] pt-1.5">{error}</p>}
                </>
            )}
        </div>
    );

    
}
